import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import PostList from '../../features/blog/components/admin/PostList';

export default function BlogManagement() {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-900">博客管理</h1>
        <Link
          to="/admin/blog/new"
          className="btn-primary flex items-center space-x-2"
        >
          <Plus className="w-4 h-4" />
          <span>写文章</span>
        </Link>
      </div>

      <div className="bg-white rounded-lg shadow-sm">
        <PostList />
      </div>
    </div>
  );
}